import { render, staticRenderFns } from "./layoutUser.vue?vue&type=template&id=c9bdbf6a&"
import script from "./layoutUser.vue?vue&type=script&lang=js&"
export * from "./layoutUser.vue?vue&type=script&lang=js&"
import style0 from "./layoutUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports